export default "__VITE_ASSET__CRw7de4R__"